import { forwardRef, useRef, useEffect, createElement } from 'react';
import { useField, Field, Label, HelpText } from '@finn-no/troika-react-input';
import classNames from 'classnames';
import warning from 'tiny-warning';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Select = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      error = _ref.error,
      id = _ref.id,
      helpText = _ref.helpText,
      label = _ref.label,
      style = _ref.style,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "className", "disabled", "error", "id", "helpText", "label", "style"]);

  if (process.env.NODE_ENV !== 'production') {
    // use a reference to only warn once per component instance
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var shouldWarn = useRef(true); // eslint-disable-next-line react-hooks/rules-of-hooks

    useEffect(function () {
      // Warn if the component isn't accessible.
      warning(label || props['aria-label'] || props['aria-labelledby'], "<Select> requires a 'label', 'aria-label' or an 'aria-labelledby' to be accessible to screen readers.");
      shouldWarn.current = false;
    });
  }

  var _useField = useField({
    id: id,
    hasError: error,
    hasHelpText: Boolean(helpText)
  }),
      controlProps = _useField.controlProps,
      helpTextProps = _useField.helpTextProps;

  return /*#__PURE__*/createElement(Field, {
    className: classNames('input--select', className),
    isDisabled: disabled,
    isInvalid: error,
    style: style
  }, /*#__PURE__*/createElement(Label, {
    htmlFor: controlProps.id
  }, label), /*#__PURE__*/createElement("div", {
    className: "input--select__wrap"
  }, /*#__PURE__*/createElement("select", _extends({}, controlProps, {
    disabled: disabled,
    ref: ref
  }, props), children)), helpText && /*#__PURE__*/createElement(HelpText, helpTextProps, helpText));
});
Select.displayName = "Select";

export { Select };
//# sourceMappingURL=index.es.js.map
